export default "__VITE_ASSET__CdD055tk__"